<!--搜索框日期-->
<template>
  <div class="vm-search-com vm-search-com_date">
    <span class="vm-search-label">{{label}}</span>
    <el-date-picker
        style="width: 100px"
        :value="startTime"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="开始日期"
        @input="onStartTimeChange"/>
    <span class="vm-search-label" style="margin-left: -5px;margin-right: -2px;color: #888">-</span>
    <el-date-picker
        style="width: 100px"
        :value="endTime"
        value-format="yyyy-MM-dd"
        type="date"
        placeholder="结束日期"
        @input="onEndTimeChange"/>
  </div>
</template>

<script>

  export default {
    props: {
      label: {
        type: String,
        required: true,
      },
      startTime: {
        type: String,
        required: true,
      },
      endTime: {
        type: String,
        required: true,
      },
    },
    data() {
      return {};
    },
    methods: {
      onStartTimeChange(value) {
        this.$emit("update:startTime", value);
      },
      onEndTimeChange(value) {
        this.$emit("update:endTime", value);
      },
    },
  };
</script>

<style lang="scss" scoped>
.vm-search-com_date {
  display: inline-flex;
  margin: 2px 0;
  align-items: center;

  .vm-search-label {
    box-sizing: border-box;
    display: inline-block;
    font-size: 12px;
    color: #333;
    line-height: 28px;
    padding-left: 10px;
    padding-right: 3px;
    white-space: nowrap;
    text-align: right;
  }
}
</style>
<style lang="scss">
.vm-search-com_date {

  .el-input:not(.el-date-editor) .el-input__inner {
    padding: 0 5px;
  }

  .el-date-editor.el-input--prefix {
    .el-input__inner {
      padding-left: 25px;
    }

    .el-input__prefix {
      left: 0;
    }
  }

  .el-date-editor.el-input--suffix {
    .el-input__inner {
      padding-right: 10px;
    }

    .el-input__suffix {
      background-color: white;
      right: 1px;
      height: 20px;
      top: 1px;
    }
  }
}
</style>
